import type React from 'react';
import type { FC } from 'react';

import CloseSmall from '@crehana/icons/outline/CloseSmall';
import { baseLighter } from '@crehana/ui/dist/styles/colors';
import { useUITheme } from '@crehana/web/Layouts/UITheme';
import { clsx } from 'clsx';

import type { DialogHeaderProps } from './types';

const DialogHeader: FC<React.PropsWithChildren<DialogHeaderProps>> = ({
  title,
  onClose,
}) => {
  const { isDark } = useUITheme();

  return (
    <div
      className={clsx(
        'flex items-center justify-between min-h-72 px-36 border-b border-solid',
        isDark ? 'border-gray-main-dark-mode' : 'border-gray-light',
      )}
    >
      <div className="font-h4">{title}</div>
      {onClose && (
        <button className="h-32" type="button" onClick={onClose}>
          <CloseSmall color={baseLighter} />
        </button>
      )}
    </div>
  );
};

export default DialogHeader;
